import { useGetGraphqlDataQuery, type UseQueryResult } from '@repo/services';
import { Select, type SelectProps } from 'antd';
import { getDealStatuses, type GetDealStatusesType } from 'crm-atoms/queries';
import { useMemo } from 'react';

export interface DealStatusMultiSelectProps extends Omit<SelectProps, 'options' | 'onFocus' | 'onChange' | 'value'> {
  value?: string[];
  onChange: (value: string[]) => void;
}

export default function DealStatusMultiSelect({
  value,
  onChange,
  ...props
}: DealStatusMultiSelectProps) {
  const {
    data,
    isLoading,
  } = useGetGraphqlDataQuery<UseQueryResult<GetDealStatusesType>>({
    document: getDealStatuses,
  });

  const options = useMemo(
    () => data?.dealStatuses?.map(({ value: val, label }) => ({ value: val, label })) ?? [],
    [data],
  );

  return (
    <Select
      mode="multiple"
      value={value}
      onChange={onChange}
      options={options}
      loading={isLoading}
      optionFilterProp="label"
      placeholder="Select deal status(es)"
      {...props}
    />
  );
}
